module.exports = __webpack_public_path__ + "img/home@3x.492d75a9.png";